<form [formGroup]="formularioContato">

  <mat-card style="box-shadow: none;" class="mat-elevation-z0 listaContato" *ngIf="showListaContato">
    <div class="d-flex justify-content-between">
      <mat-card-title style="margin-top: 10px; font-size: 18px;" class="card-title-font">
        Lista de contatos
      </mat-card-title>

      <button mat-icon-button mat-dialog-close (click)="abrirListaContato()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="row justify-content-center">
      <mat-form-field style="width: 80%; font-size: 14px;">
        <mat-label>Pesquisar cliente</mat-label>
        <input matInput type="text" formControlName="Cliente">
        <button matSuffix mat-icon-button aria-label="Clear" (click)="BuscarCliente()">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z" />
            <path fill-rule="evenodd"
              d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" />
          </svg>
        </button>

        <!-- <button *ngIf="formularioContato.value.idCliente != null" (click)="limparCampos()" mat-button matSuffix
            mat-icon-button aria-label="Clear">
            <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button> -->
      </mat-form-field>
    </div>

    <div class="row justify-content-center">
      <mat-form-field style="width: 80%; font-size: 14px;">
        <mat-label>Selecionar contato</mat-label>
        <input type="text" formControlName="Contato" matInput [disabled]="formularioContato.value.idCliente == null"
          [matAutocomplete]="auto">
        <mat-autocomplete (optionSelected)="selecionaContato($event)" autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let option of filtrarContatos" [value]="option"
            [displayWith]="option.Contato + ' - ' + option.Telefone">{{option.Contato}} -
            {{option.Telefone}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <br>
    <div class="d-flex align-bottom justify-content-center">
      <div style="width: 15px;"></div>
      <button mat-raised-button color="green" (click)="iniciarConversa()"
        [disabled]="formularioContato.value.Cliente == null || formularioContato.value.Cliente == '' || formularioContato.value.Contato == null || formularioContato.value.Contato == ''">
        <mat-icon>chat</mat-icon>
        Enviar mensagem
      </button>
    </div>
  </mat-card>

  <mat-card style="box-shadow: none;" class="mat-elevation-z0 assunto backgroundwpp" *ngIf="showAssunto"
    [ngClass]="{'opened': showAssunto, 'closing': isClosingAssunto}">



    <div class="flex-column">
      <div style="background-color: aliceblue;padding-left: 30px;">
        <div class="row" style="font-size: 13px;">
          <b>Cliente:</b>&nbsp; {{formularioContato.value.Cliente}}
        </div>

        <div class="row" style="font-size: 13px;">
          <b>Contato:</b>&nbsp; {{formularioContato.value.Contato}}

        </div>
      </div>
      <br>
      <app-chat-extends *ngIf="Conversa.length > 0">
        <app-chat-message-extends *ngFor="let msg of Conversa" class="message" [type]="msg.type" [message]="msg.text"
          [reply]="msg.reply" [sender]="msg.user.name" [date]="msg.date" [files]="msg.files" [quote]="msg.quote"
          [customMessage]="msg.customMessage" [avatar]="avatar"></app-chat-message-extends>
      </app-chat-extends>

      <mat-form-field class="assuntoField" appearance="outline" style="width: 100%; background-color: aliceblue;">
        <textarea matInput style="width: 100%; height: 100%; font-size: 600;" formControlName="Assunto"
          placeholder="Escreva de forma resumida o assunto."></textarea>
      </mat-form-field>
    </div>
    <div class="row justify-content-center" style="margin-top: 10px;">
      <button mat-raised-button (click)="fecharIniciarConversa()" color="warn"
        style="margin-right: 12px;">Voltar</button>
      <button mat-raised-button (click)="enviaPrimeiraMensagem()" color="send">Enviar<mat-icon
          style="margin-left: 8px;">send</mat-icon></button>
    </div>

  </mat-card>
</form>